import { generaLivello } from "./utility.js";
export default function primoLivello(k) {
    k.scene("primoLivello", () => {
        const LIVELLO = [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            " @           $$$$$$$$$$$$$   >",
            " ===============================",
        ];
        generaLivello(k, LIVELLO, "secondoLivello");
    });
}